// 工具方法
import * as utils from 'js/utils/index'

/**
 * 滑块图片按长宽比调整宽高
 * @param {Array} imgs img 元素数组
 * @param {Object} ht 横图、纵图高度及其单位
 */
export function imgResize (options = {}) {
  options = Object.assign({}, options)

  return new Promise((resolve, reject) => {
    if (!(argsInit(options) && argsValidate(options))) {
      return reject()
    }

    let {
      imgs,
      ht,
    } = options
    let maxLen = imgs.length
    let cnt = 0 // 加载完毕计数器

    let timer = setInterval(() => {
      for (let img of imgs) {
        if (img.complete) {
          if (typeof img.naturalWidth !== 'undefined') {
            // 兼容IE9+
            let ratio = (img.naturalWidth / img.naturalHeight)
            let wt // 宽度
            let height // 高度
            let unit // 单位

            if (ratio > 1) {
              height = ht.horiz.value
              unit = ht.horiz.unit
            } else {
              height = ht.verti.value
              unit = ht.verti.unit
            }

            wt = ((height * ratio).toFixed(3) * 1000 / 1000)

            $(img).css({
              'width': `${wt}${unit}`,
              'height': `${height}${unit}`
            })
            $(img).parent('.swiper-slide').css({
              'width': `${wt}${unit}`
            })

            let index = imgs.findIndex(ele => {
              return img === ele
            })
            imgs.splice(index, 1)
            cnt++
          } else {
            utils.log.e('[posterInit] failed: 浏览器不支持 naturalWidth 属性')
            reject()
            clearInterval(timer)
            break
          }
        }

        if (cnt >= maxLen) {
          resolve()
          clearInterval(timer)
        }
      }
    }, 300)
  })
}

/**
 * 参数初始化
 */
function argsInit (options = {}) {
  let {
    imgs,
    ht = {
      horiz: {
        value: 8.75,
        unit: 'rem',
      },
      verti: {
        value: 12.75,
        unit: 'rem',
      },
    },
  } = options

  options.ht = ht

  if (typeof imgs === 'string') {
    let obj = document.querySelectorAll(imgs)

    if (obj.length === 0) {
      utils.log.e(`${from}[argsInit] DOM element whose selector's ${imgs} not found.`)
      return false
    }

    options.imgs = Array.from(obj)
  }

  if (typeof ht === 'object') {
    options.ht = Object.assign({
      horiz: {
        value: 8.75,
        unit: 'rem',
      },
      verti: {
        value: 12.75,
        unit: 'rem',
      },
    }, ht)
  }

  return true
}

/**
 * 参数校验
 */
function argsValidate (options = {}) {
  let {
    imgs,
    ht,
  } = options
  let from = '[swiper][imgResize][argsValidate]'

  if (imgs instanceof Array) {
    for (let img of imgs) {
      if (!(img instanceof HTMLElement)) {
        utils.log.e(`${from} img is not an instance of Image.`)
        return false
      }
    }
  } else {
    utils.log.e(`${from} imgs is not an instance of Array.`)
    return false
  }

  if (typeof ht !== 'object') {
    utils.log.e(`${from} invalid argument ht.`)
    return false
  }

  return true
}


// WEBPACK FOOTER //
// ./js/animation/swiper/imgResize.js